import { getOutlineColor as getGlobalOutlineColor } from './global';
import { INTERACTION_STATE_FOCUS_VISIBLE } from '../../../../constants';
export function getOutlineColor(transformer) {
    const globalOutlineColor = getGlobalOutlineColor(transformer);
    return Object.freeze({
        default: {
            interactionStates: {
                [INTERACTION_STATE_FOCUS_VISIBLE]: {
                    value: globalOutlineColor.purple900,
                },
            },
        },
    });
}
